/**
 * Properties that aren't user-friendly to display or are handled separately
 */

/**
 * Converts a camelCase string to Title Case with spaces
 * Intelligently handles acronyms by keeping consecutive capitals together
 * Examples:
 * - "firstName" -> "First Name"
 * - "lastName" -> "Last Name"
 * - "companyVATNumber" -> "Company VAT Number"
 *
 * @param str - The string in camelCase
 * @returns The string in Title Case with proper spacing
 */
export const toCapitalStringWithSpaces = (str: string): string => {
  if (!str) return ""

  // Smart acronym detection:
  // 1. Add space between lowercase and uppercase (camelCase boundary)
  // 2. Add space between consecutive capitals when followed by lowercase (XMLParser -> XML Parser)
  const spacedString = str
    .replace(/([a-z])([A-Z])/g, "$1 $2") // camelCase boundary
    .replace(/([A-Z]+)([A-Z][a-z])/g, "$1 $2") // acronym before word
    .trim()

  // Capitalize each word, but preserve acronyms (all uppercase words)
  return spacedString
    .split(/\s+/)
    .map((word) => {
      // If word is all uppercase (acronym), keep it uppercase
      if (word === word.toUpperCase() && word.length > 1) {
        return word
      }
      // Otherwise, capitalize first letter and lowercase the rest
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    })
    .join(" ")
}
